import type { EntityViewRow } from "#app/lib/data";

import type { EntityViewsScope } from "#app/lib/hooks/use-entity-views";

/**
 * The one place that knows a saved view's URL.
 *
 * A scope's built-in views keep the segments they have always had
 * (`/workflow/<id>/list`) so an existing link, a bookmark and
 * `preferences.defaultRoute` all survive; everything added since is
 * `/view/<viewId>`, because a name is renameable and an id is not. A
 * workspace dashboard is its own page under the Dashboards module — the
 * workspace is the URL's root already, so the scope id never appears.
 */
export function viewPath(scope: EntityViewsScope, view: EntityViewRow): string {
  if (scope.kind === "workspace") return `/dashboards/${view.id}`;
  const base = `/${scope.kind}/${scope.id}`;
  return view.builtInKey
    ? `${base}/${view.builtInKey}`
    : `${base}/view/${view.id}`;
}

/** The view a route segment names — a built-in key or a view id. */
export function findViewByKey(
  views: EntityViewRow[],
  key: string | null,
): EntityViewRow | null {
  if (!key) return null;
  return (
    views.find((view) => view.id === key) ??
    views.find((view) => view.builtInKey === key) ??
    null
  );
}
